<template>
  <div>
    <div id="upgradeConfirmation">
      <h1>Confirm Plan Upgrade</h1>
      <div class="steps-container clearfix">
        <ul class="steps-progressbar">
          <li class="step-active">select plan</li>
          <li class="step-active">select payment</li>
          <li class="step-active">confirmation</li>
        </ul>
      </div>
      <div class="confirmationBox">
        New Plan: <br />{{ selectedPlan && selectedPlan.name }}
        {{ selectedPlan.description }}<br />
        ${{ selectedPlan.billing_term_cost }}.00 / month<br />
        Length of Plan: {{ selectedPlan.plan_term_months }} months<br />
        Number of Properties Allowed: {{ selectedPlan.limit_property }}<br />
        Number of Users Allowed: {{ selectedPlan.limit_user }}<br /><br />
        Payment: <br />
        Card Type: {{ billingEntry && billingEntry.payment_method }} <br />
        Card Last 4: {{ billingEntry && billingEntry.payment_last_4 }} <br />
        Card Exp Date: {{ billingEntry && billingEntry.payment_exp_date }}
        <br />
      </div>
      <div class="center-text">
        <button
          tag="button"
          name="confirmUpgradeButton"
          class="button button-200"
          @click="upgrade"
        >
          Purchase Upgrade</button
        ><br />
        <button
          name="cancelUpgrade"
          class="button-cancel button-100"
          @click="cancel"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/index";
const apiServiceBilling = new api.APIServiceBilling();
const apiServiceSubscription = new api.APIServiceSubscription();

export default {
  name: "ConfirmUpgradeComponent",
  props: {
    plan: {
      default: 0,
      type: Number
    },
    billing: {
      default: 0,
      type: Number
    }
  },
  data() {
    return {
      billingEntry: {},
      selectedPlan: {}
    };
  },
  computed: {
    // selectedPlan () {
    //   return this.$store.getters.plan;
    // }
  },
  watch: {
    // whenever question changes, this function will run
    plan: function(newID, oldID) {
      // console.log('Plan ID Change ' + newID + ' ' + oldID);
    }
  },
  mounted() {
    if (this.plan > 0) {
      // this.$store.dispatch('getPlanByID', this.plan);
      this.getPlanByID();
    }
    if (this.billing > 0) {
      this.getAccountBillingEntry();
    }
  },
  methods: {
    upgrade: function() {
      // emit confirm upgrade
      this.$emit("confirm-upgrade");
    },
    cancel: function() {
      this.$emit("cancel");
    },
    getAccountBillingEntry: function() {
      apiServiceBilling.getAccountBillingEntry(this.billing).then(data => {
        if (data) {
          this.billingEntry = data.data[0];
        }
      });
    },
    getPlanByID: function() {
      apiServiceSubscription.getPlanByID(this.plan).then(data => {
        if (data) {
          this.selectedPlan = data.data[0];
        }
      });
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 24px;
}
h2 {
  font-size: 18px;
}
h3 {
  font-size: 18px;
  margin-bottom: 0;
}
#upgradeConfirmation {
  lost-utility: clearfix;
}
.confirmationBox {
  background: #d5e3f4;
  padding: 15px;
  border-radius: 4px;
  lost-utility: clearfix;
  width: 400px;
  margin: 30px auto;
}
.steps-container {
  width: 600px;
  margin: 30px auto;
}
.steps-progressbar {
  counter-reset: step;
}
.steps-progressbar li {
  list-style-type: none;
  width: 33%;
  float: left;
  font-size: 12px;
  position: relative;
  text-align: center;
  text-transform: uppercase;
  color: #7d7d7d;
}
.steps-progressbar li:before {
  width: 30px;
  height: 30px;
  content: counter(step);
  counter-increment: step;
  line-height: 30px;
  border: 2px solid #7d7d7d;
  display: block;
  text-align: center;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  background-color: white;
}
.steps-progressbar li:after {
  width: 100%;
  height: 2px;
  content: "";
  position: absolute;
  background-color: #7d7d7d;
  top: 15px;
  left: -50%;
  z-index: -1;
}
.steps-progressbar li:first-child:after {
  content: none;
}
.steps-progressbar li.step-active {
  color: #5584c0;
}
.steps-progressbar li.step-active:before {
  border-color: #5584c0;
}
.steps-progressbar li.step-active + li:after {
  background-color: #5584c0;
}
@media (max-width: 800px) {
  .billingMethod {
    lost-column: 1/2;
  }
  .steps-progressbar {
    width: 80%;
  }
}
@media (max-width: 640px) {
  .billingMethod {
    lost-column: 1/1;
  }
  .steps-progressbar {
    width: 90%;
  }
}
</style>
